export function SectionDivider({ label }) {
    return (
        <div className="pt-4 mt-2 border-t border-paper-border-soft">
            <div className="text-xs uppercase tracking-wider font-semibold text-ink-subtle">
                {label}
            </div>
        </div>
    );
}
